import React, { Component } from "react";
import ReactDOM from "react-dom";
import Authorreview from "../Components/Authorreview";
import Mainslider from "../Components/Mainslider";
import Banner1 from "../Components/Banner1";
import Banner2 from "../Components/Banner2";
import Brandlogo from "../Components/Brandlogo";
import Footer from "../Components/Footer";
import Freehomedelivery from "../Components/Freehomedelivery";
import Header from "../Components/Header";
import Blog from "../Components/Blog";
import Latestpost from "../Components/Blog";
import Popularfurniture from "../Components/Popularfurniture";

class Home extends React.Component {
  render() {
    return (
      <div id="main-wrapper">
        <Mainslider />
        <Banner1 />
        <Popularfurniture />
        <Banner2 />
        <Freehomedelivery />
        <Blog />
        <Authorreview />
        <Brandlogo />
      </div>
    );
  }
}
export default Home;
